<div id="calendar" class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div *ngIf="!isScheduleView" class="calendar-header" [ngClass]="viewDate | date: 'MMM'">
        <div class="header-content mt-0" fxLayout="column">
            <div class="header-top" fxFlex="100" fxLayout="row" fxLayout.xs="column"
                fxLayoutAlign="space-around center">
                <div fxFlex></div>

                <div fxFlex class="text-right pr-20" fxLayoutGap="10px">
                    <span class="header-img-default" *ngIf="
                            calendarConfig && calendarConfig.syncCalenarEvents
                        ">
                        <button mat-fab (click)="syncEventsWithCalendar()">
                            <img src="{{ calendarEventConfig.googleCalEventImageUrl }}" alt="Google Calendar Event" />
                        </button>
                    </span>
                </div>
            </div>

            <!-- / TOOLBAR -->
            <!-- <div class="header-top">
                <div class="toolbar" class="text-center">

                    <button mat-icon-button
                            mwlCalendarToday
                            (click)="view='day'; setQueryParams()"
                            [(viewDate)]="viewDate"
                            (viewDateChange)="selectedDay = {date:$event}"
                            aria-label="Today" matTooltip="Today">
                        <mat-icon>today</mat-icon>
                    </button>

                    <button mat-icon-button [ngClass]="{'active': view == 'day'}" (click)="view='day'; setQueryParams()" *ngIf="enabledViews.day"
                        aria-label="Day" matTooltip="Day">
                        <mat-icon>view_day</mat-icon>
                    </button>

                    <button mat-icon-button [ngClass]="{'active': view == 'week'}" (click)="view='week'; setQueryParams()" *ngIf="enabledViews.week"
                        aria-label="Week" matTooltip="Week">
                        <mat-icon>view_week</mat-icon>
                    </button>

                    <button mat-icon-button [ngClass]="{'active': view == 'month'}" (click)="view='month'; setQueryParams()" *ngIf="enabledViews.month"
                        aria-label="Month" matTooltip="Month">
                        <mat-icon>view_module</mat-icon>
                    </button>
                </div>
            </div> -->
            <!-- HEADER BOTTOM -->
            <!-- <div
                class="header-bottom"
                fxLayout="row"
                fxLayoutAlign="space-between center"
            > -->
            <div fxLayout="row" fxLayoutAlign="center center" style="font-size: 16px; line-height: 23px" class="pb-16">
                <button fxLayout="column" fxLayoutAlign="center center" mat-icon-button class="arrow"
                    mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
                    (viewDateChange)="selectedDay = { date: $event }" aria-label="Previous">
                    <mat-icon class="mat-icon-color font-size-24">chevron_left</mat-icon>
                </button>

                <!-- <div class="">
                    {{ viewDate | calendarDate : view + 'ViewTitle' : locale : weekStartsOn }}
                </div> -->

                <div class="">
                    {{ viewDate | CustomCalendarWeeklyDatePipe }}
                </div>

                <button fxLayout="column" fxLayoutAlign="center center" mat-icon-button class="arrow"
                    mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                    (viewDateChange)="selectedDay = { date: $event }" aria-label="Next">
                    <mat-icon class="mat-icon-color font-size-24">chevron_right</mat-icon>
                </button>
            </div>
            <!-- <div fxLayout="row">
                <mat-chip-set>
                    <mat-chip
                        *ngFor="let type of viewTypes"
                        [ngClass]="{
                            'chip-active': type.value == selectedViewType
                        }"
                        (click)="changeViewType(type.value)"
                    >
                        {{ type.key | translate }}
                    </mat-chip>
                </mat-chip-set>
            </div> -->
            <div class="tab-btns" fxLayout="row" fxLayoutGap="8px">
                <button class="projects-project w-50-p tab-btn py-12" [ngClass]="{
                        scheduledBtnEnabled: isScheduleView
                    }" [disabled]="isScheduledBtnEnabled" (click)="changeViewType('schedule')">
                    {{ 'SCHEDULED' | translate }}
                </button>
                <button class="wishlist w-50-p tab-btn py-12" [ngClass]="{
                        weeklyBtnEnabled: !isScheduleView
                    }" [disabled]="isWeeklyBtnEnabled" (click)="changeViewType('week')">
                    {{ 'WEEKLY' | translate }}
                </button>
            </div>
            <!-- </div> -->
            <!-- / HEADER BOTTOM -->
        </div>

        <!-- ADD EVENT BUTTON -->
        <!-- <button
            mat-fab
            class="add-event-button mat-warn"
            *ngIf="hasPermissionToAddEvent"
            (click)="addEvent()"
            aria-label="Add event"
        >
            <mat-icon>add</mat-icon>
        </button> -->
        <!-- / ADD EVENT BUTTON -->
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div *ngIf="!isScheduleView" class="content">
        <div [ngSwitch]="view">
            <!-- <mwl-calendar-month-view
                *ngSwitchCase="'month'"
                [viewDate]="viewDate"
                [weekStartsOn]="weekStartsOn"
                [locale]="locale"
                [weekendDays]="weekendDays"
                [events]="events"
                [refresh]="refresh"
                [activeDayIsOpen]="activeDayIsOpen"
                [cellTemplate]="customMonthTemplate"
                (dayClicked)="dayClicked($event.day)"
                (eventClicked)="editEvent('edit', $event.event)"
                (eventTimesChanged)="eventTimesChanged($event)"
                (beforeViewRender)="beforeMonthViewRender($event)"
            >
            </mwl-calendar-month-view> -->
            <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate" [weekStartsOn]="weekStartsOn"
                [locale]="locale" [weekendDays]="weekendDays" (viewDateChange)="selectedDay = { date: $event }"
                [tooltipTemplate]="tooltipTemplate" [events]="events" [refresh]="refresh"
                (eventClicked)="editEvent('edit', $event.event)" (eventTimesChanged)="eventTimesChanged($event)"
                (beforeViewRender)="beforeWeekViewRender($event)">
            </mwl-calendar-week-view>
            <!-- <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate" (viewDateChange)="selectedDay = {date:$event}" [locale]="locale"
                [events]="events" [refresh]="refresh" (dayClicked)="dayClicked($event.day)" (eventClicked)="editEvent('edit', $event.event)"
                (eventTimesChanged)="eventTimesChanged($event)" (beforeViewRender)="beforeDayViewRender($event)">
            </mwl-calendar-day-view> -->
        </div>
    </div>

    <div class="schedule-view" *ngIf="isScheduleView">
        <!-- SCHEDULEVIEW HEADER -->
        <div class="calendar-header pb-24">
            <div class="header-content" fxLayout="column">
                <div class="w-100-p" fxLayout="row" fxLayoutAlign="center center"
                    style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5);"
                    *ngIf="loadingEvents">
                    <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                        <mat-spinner diameter="44"></mat-spinner>
                    </div>
                </div>

                <div *ngIf="!loadingEvents" fxLayout="row" fxLayoutAlign="center center" class="pb-16">
                    <button fxLayout="column" fxLayoutAlign="center center" mat-icon-button class="arrow"
                        (click)="adjustSchedule(-2)" aria-label="Previous">
                        <mat-icon class="mat-icon-color font-size-24">chevron_left</mat-icon>
                    </button>

                    <div class="title">
                        {{ startDateForScheduleView }}
                        {{ currentMonthName }} {{ currentYear }} -
                        {{ endDateForScheduleView }}
                        {{ nextSecondMonthName }} {{ nextYear }}
                    </div>

                    <button fxLayout="column" fxLayoutAlign="center center" mat-icon-button class="arrow"
                        (click)="adjustSchedule(2)" aria-label="Next">
                        <mat-icon class="mat-icon-color font-size-24">chevron_right</mat-icon>
                    </button>
                </div>

                <div class="tab-btns" fxLayout="row" fxLayoutGap="8px">
                    <button class="projects-project w-50-p tab-btn py-12" [ngClass]="{
                            scheduledBtnEnabled: isScheduleView
                        }" [disabled]="isScheduledBtnEnabled" (click)="changeViewType('schedule')">
                        {{ 'SCHEDULED' | translate }}

                    </button>
                    <button class="wishlist w-50-p tab-btn py-12" [ngClass]="{
                            weeklyBtnEnabled: !isScheduleView
                        }" [disabled]="isWeeklyBtnEnabled" (click)="changeViewType('week')">
                        {{ 'WEEKLY' | translate }}

                    </button>
                </div>
            </div>
        </div>

        <div class="content pt-0">
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="list-content"
                *ngFor="let schedule of formatedSchedulesForListView">
                <div class="project-date">
                    <p class="fs-16 bold">{{ schedule.date | date: 'd' }}</p>
                    <p class="fs-10 bold">
                        {{ schedule.date | date: 'MMM':locale:locale }}
                    </p>
                </div>

                <div class="m-0 w-100-p">
                    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="schedule-event mb-12"
                        *ngFor="let event of schedule.events" (click)="editEvent('edit', event)">
                        <div class="left-content">
                            <div class="dot mt-4" [ngClass]="{
                                    dotBooked: event.emebeddedInfo.status == 'booked',
                                    dotReserved: event.emebeddedInfo.status == 'reserved',
                                    dotRequested: event.emebeddedInfo.status == 'invited',
                                    dotLeave: event.emebeddedInfo.ScheduleType == 'leave',
                                    scheduled: event.emebeddedInfo.status == 'scheduled',
                                    accepted: event.emebeddedInfo.status == 'accepted',
                                    rejected: event.emebeddedInfo.status == 'rejected'
                                }"></div>
                            <div>
                                <div class="fs-16 bold pb-4">
                                    {{ event.title | truncate: 25:'...' | translate }}
                                </div>
                                <div class="fs-12 bold gray-color pb-4">{{ event.emebeddedInfo.ArticleName | truncate:
                                    25:'...' }}</div>
                                <div class="br-2">
                                    <ng-container
                                        *ngIf="event.emebeddedInfo.status !== 'reserved'; else reservedContent">
                                        <span *ngIf="event.emebeddedInfo.Description !== 'holiday'" class="fs-10 bold gray-color">
                                            <span *ngIf="event.emebeddedInfo.ScheduleType === 'leave'">{{ '00:00'}} - {{ '23:59' }}</span>
                                            <span *ngIf="event.emebeddedInfo.ScheduleType !== 'leave'">{{ event.start | date: 'HH:mm' }} - {{ event.end | date: 'HH:mm' }}</span>
                                        </span>
                                    </ng-container>
                                    <ng-template #reservedContent>
                                        <div style="height: 16px;"></div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                        <div fxFlex></div>
                        
                        <div *ngIf="event.emebeddedInfo.ScheduleType === 'work'" class="status" fxFlexAlign="center" [ngClass]="{
                                requested: event.emebeddedInfo.status == embeddedInfoStatus.invited,
                                accepted: event.emebeddedInfo.status == embeddedInfoStatus.accepted,
                                booked: event.emebeddedInfo.status == embeddedInfoStatus.booked,
                                scheduled: event.emebeddedInfo.status == embeddedInfoStatus.scheduled,
                                rejected: event.emebeddedInfo.status == embeddedInfoStatus.rejected,
                                reserved: event.emebeddedInfo.status == embeddedInfoStatus.reserved
                            }">
                            <span *ngIf="event.emebeddedInfo.status == embeddedInfoStatus.invited">{{ 'REQUESTED' | translate }}</span>
                            <span *ngIf="event.emebeddedInfo.status === embeddedInfoStatus.accepted"> {{ 'ACCEPTED' | translate }}</span>                            <span *ngIf="event.emebeddedInfo.status == embeddedInfoStatus.booked">{{ 'BOOKED' | translate }}</span>
                            <span *ngIf="event.emebeddedInfo.status == embeddedInfoStatus.scheduled">{{ 'SCHEDULED' | translate }}</span>
                            <span *ngIf="event.emebeddedInfo.status == embeddedInfoStatus.rejected">{{ 'REJECTED' | translate }}</span>
                            <span *ngIf="event.emebeddedInfo.status == embeddedInfoStatus.reserved">{{ 'RESERVED' | translate }}</span>
                        </div>
                        <div *ngIf="event.emebeddedInfo.ScheduleType === 'leave'"
                            class="status"
                            fxFlexAlign="center"
                            [ngClass]="{
                                accepted: event.emebeddedInfo.ActionStatus == schedulesEmployeeActionStatus.accepted || event.emebeddedInfo.ActionStatus == schedulesEmployeeActionStatus.partial,
                                rejected: event.emebeddedInfo.ActionStatus == schedulesEmployeeActionStatus.rejected,
                                pending: event.emebeddedInfo.ActionStatus == schedulesEmployeeActionStatus.pending
                            }">
                            <span *ngIf="event.emebeddedInfo.ActionStatus == schedulesEmployeeActionStatus.accepted || event.emebeddedInfo.ActionStatus == schedulesEmployeeActionStatus.partial">{{ event.emebeddedInfo.isAssigned ? ('Assigned' | translate) : ('ACCEPTED' | translate) }}</span>
                            <span *ngIf="event.emebeddedInfo.ActionStatus == schedulesEmployeeActionStatus.rejected">{{ 'REJECTED' | translate }}</span>
                            <span *ngIf="event.emebeddedInfo.ActionStatus == schedulesEmployeeActionStatus.pending">{{ 'PENDING' | translate }}</span>
                        </div>

                        <!-- <div *ngIf="event.emebeddedInfo.ScheduleType === 'leave' && ['Vacation', 'Day-Off'].includes(event.emebeddedInfo.LeaveType)"
                            class="status" [ngClass]="{
                                                        accepted: event.emebeddedInfo.ActionStatus == 'accepted',
                                                        rejected: event.emebeddedInfo.ActionStatus == 'rejected',
                                                        pending: event.emebeddedInfo.ActionStatus == 'pending'
                                                    }">
                            <span *ngIf="event.emebeddedInfo.ActionStatus == 'accepted'">{{ 'ACCEPTED' |
                                translate }}</span>
                            <span *ngIf="event.emebeddedInfo.ActionStatus == 'rejected'">{{ 'REJECTED' |
                                translate }}</span>
                            <span *ngIf="event.emebeddedInfo.ActionStatus == 'pending'">{{ 'PENDING' | translate
                                }}</span>
                        </div>
                        <div *ngIf="event.emebeddedInfo.ScheduleType === 'leave' && !['Vacation', 'Day-Off'].includes(event.emebeddedInfo.LeaveType)"
                            class="status" [ngClass]="{                                accepted: event.emebeddedInfo.ActionStatus == 'accepted',
                                rejected: event.emebeddedInfo.ActionStatus == 'rejected',
                                pending: event.emebeddedInfo.ActionStatus == 'pending'
                            }">
                            <span *ngIf="event.emebeddedInfo.ActionStatus == 'accepted'">{{ 'ACCEPTED' | translate
                                }}</span>
                            <span *ngIf="event.emebeddedInfo.ActionStatus == 'rejected'">{{ 'REJECTED' | translate
                                }}</span>
                            <span *ngIf="event.emebeddedInfo.ActionStatus == 'pending'">{{ 'PENDING' | translate
                                }}</span>
                        </div> -->
                    </div>
                </div>

                <!-- <mat-divider></mat-divider> -->
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" *ngIf="
                    formatedSchedulesForListView.length === 0 && !loadingEvents
                " class="data-not-found">
                <p class="bold p-8">{{'NO_SCHEDULE_FOUND' | translate}}</p>
            </div>
        </div>
    </div>
</div>

<ng-template #customMonthTemplate let-day="day" let-openDay="openDay" let-locale="locale"
    let-tooltipPlacement="tooltipPlacement" let-highlightDay="highlightDay" let-unhighlightDay="unhighlightDay"
    let-eventClicked="eventClicked" let-tooltipTemplate="tooltipTemplate" let-tooltipAppendToBody="tooltipAppendToBody">
    <div class="cal-cell-top" [style.backgroundColor]="
            day?.events[0]?.color?.secondary &&
            day?.events[0]?.color?.primary == ''
                ? day?.events[0]?.color?.secondary
                : ''
        ">
        <span class="cal-day-badge" *ngIf="day.badgeTotal > 0">{{
            day.badgeTotal
            }}</span>
        <span class="cal-day-number">{{
            day.date | calendarDate: 'monthViewDayNumber':locale
            }}</span>
    </div>
    <div class="cal-events" *ngIf="day.events.length > 0" [style.backgroundColor]="
            day?.events[0]?.color?.secondary &&
            day?.events[0]?.color?.primary == ''
                ? day?.events[0]?.color?.secondary
                : ''
        " [ngClass]="{
            'm-0':
                day?.events[0]?.color?.secondary &&
                day?.events[0]?.color?.primary == ''
        }">
        <div fxLayout="row" *ngFor="let event of day.events; trackBy: identify" [mwlCalendarTooltip]="
                event.title | calendarEventTitle: 'monthTooltip':event
            " [tooltipPlacement]="tooltipPlacement" [tooltipEvent]="event" [tooltipTemplate]="tooltipTemplate"
            [tooltipAppendToBody]="tooltipAppendToBody">
            <div class="month-event-point ml-8">
                <div class="cal-event" [style.backgroundColor]="event.color?.primary" [ngClass]="event?.cssClass"
                    (mouseenter)="highlightDay.emit({ event: event })"
                    (mouseleave)="unhighlightDay.emit({ event: event })" mwlDraggable
                    [class.cal-draggable]="event.draggable" dragActiveClass="cal-drag-active"
                    [dropData]="{ event: event, draggedFrom: day }"
                    [dragAxis]="{ x: event.draggable, y: event.draggable }"
                    (mwlClick)="eventClicked.emit({ event: event })"></div>
            </div>
            <p class="month-event-title">
                {{ event.title | truncate: 6:'...' }}
            </p>
        </div>
    </div>
</ng-template>

<ng-template #tooltipTemplate>
    <div style="display: none"></div>
</ng-template>

<!-- <ng-template #customEventTemplate let-event="event">
    <div [class.event-active]="event?.meta?.selected">
        {{event?.title}}
    </div>
</ng-template> -->
